import { CustomTemplate } from 'types/template';
import WizardButtonWrapper from '../../Wizard/WizardButtonWrapper';
import TemplateReview from '../TemplateReview';

interface LaunchCustomTemplateProps {
  selectedTemplate: CustomTemplate;
  onModalClose: () => void;
  onLaunch: () => void;
  onSave: () => void;
}

export default function LaunchCustomTemplate({
  selectedTemplate,
  onModalClose,
  onLaunch,
  onSave,
}: LaunchCustomTemplateProps) {
  return (
    <div className="d-flex flex-column">
      <TemplateReview
        description={selectedTemplate.description}
        channels={selectedTemplate.channels}
        label={selectedTemplate.label}
      />
      <div className="mt-4">
        <WizardButtonWrapper
          onModalClose={onModalClose}
          buttonProps={[
            {
              onClick: onLaunch,
              text: 'Launch',
              isPrimary: true,
            },
            {
              onClick: onSave,
              text: 'Save',
            },
            {
              onClick: () => {
                onSave();
                onLaunch();
              },
              text: 'Save & Launch',
            },
          ]}
        />
      </div>
    </div>
  );
}
